import React, {useEffect, useState} from "react";
import { motion } from 'framer-motion';

export default function LoginModal({ isOpen, onSuccess, clientPassword, pageToken }) {
    const [password, setPassword] = useState("");

    // 🔑 Auto-check for token on mount
    useEffect(() => {
        const token = localStorage.getItem("authToken-" + pageToken);
        if (token) {
            onSuccess();
        }
    }, [onSuccess]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === clientPassword) {
            localStorage.setItem("authToken-" + pageToken, "token" + pageToken);
            onSuccess(); // tell parent login worked
        } else {
            alert("Mot de passe incorrect ❌");
        }

        setPassword("");
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            className="login-modal-backdrop">
            <div className="login-modal-modal">
                <h2>🔐</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        name="password"
                        type="password"
                        placeholder="Entrer le mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {password.trim() !== "" && (
                        <button type="submit"
                                className="theme-btn btn-style-one small">
                           Afficher la page !
                        </button>
                    )}
                </form>
            </div>
        </motion.div>
    );
}

